var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { PureComponent } from 'react';
import Sidebar from '../../components/Sidebar/Sidebar';
import Timeline from '../../components/Timeline';
import { addListener, removeListener } from '../../utils/events';
import raf from '../../utils/raf';
import getNumericPropertyValue from '../../utils/getNumericPropertyValue';
var noop = function () { };
var Layout = /** @class */ (function (_super) {
    __extends(Layout, _super);
    function Layout(props) {
        var _this = _super.call(this, props) || this;
        _this.setHeaderHeight = function (headerHeight) {
            _this.setState({ headerHeight: headerHeight });
        };
        _this.scrollToNow = function () {
            var _a = _this.props, time = _a.time, scrollToNow = _a.scrollToNow, now = _a.now, timelineViewportWidth = _a.timelineViewportWidth;
            if (!_this.timeline.current || !now || !timelineViewportWidth) {
                return;
            }
            if (scrollToNow) {
                _this.timeline.current.scrollLeft = time.toX(now) - 0.5 * timelineViewportWidth;
            }
        };
        _this.updateTimelineBodyScroll = function () {
            var scrollLeft = _this.state.scrollLeft;
            if (!_this.timeline.current) {
                return;
            }
            _this.timeline.current.scrollLeft = scrollLeft;
        };
        _this.updateTimelineHeaderScroll = function () {
            if (!_this.timeline.current) {
                return;
            }
            var scrollLeft = _this.timeline.current.scrollLeft;
            _this.setState({ scrollLeft: scrollLeft });
        };
        _this.handleHeaderScrollY = function (scrollLeft) {
            raf(function () {
                _this.setState({ scrollLeft: scrollLeft });
            });
        };
        _this.handleScrollY = function () {
            raf(function () {
                var headerHeight = _this.state.headerHeight;
                var markerHeight = 0;
                if (!_this.timeline.current) {
                    return;
                }
                var _a = _this.timeline.current.getBoundingClientRect(), top = _a.top, bottom = _a.bottom;
                var isSticky = top <= -markerHeight && bottom >= headerHeight;
                _this.setState(function () { return ({ isSticky: isSticky }); });
            });
        };
        _this.handleScrollX = function () {
            raf(_this.updateTimelineHeaderScroll);
        };
        _this.calculateSidebarWidth = function () {
            if (!_this.sidebar.current || !_this.layout.current) {
                return;
            }
            return _this.sidebar.current.offsetWidth + getNumericPropertyValue(_this.layout.current, 'margin-left');
        };
        _this.calculateTimelineViewportWidth = function () {
            if (!_this.timeline.current) {
                return;
            }
            return _this.timeline.current.offsetWidth;
        };
        _this.handleLayoutChange = function (cb) {
            if (cb === void 0) { cb = noop; }
            var _a = _this.props, sidebarWidth = _a.sidebarWidth, timelineViewportWidth = _a.timelineViewportWidth, onLayoutChange = _a.onLayoutChange;
            var nextSidebarWidth = _this.calculateSidebarWidth();
            var nextTimelineViewportWidth = _this.calculateTimelineViewportWidth();
            if (nextSidebarWidth !== sidebarWidth || nextTimelineViewportWidth !== timelineViewportWidth) {
                onLayoutChange({
                    sidebarWidth: _this.calculateSidebarWidth(),
                    timelineViewportWidth: _this.calculateTimelineViewportWidth(),
                }, cb);
            }
        };
        _this.handleResize = function () { return _this.handleLayoutChange(); };
        _this.timeline = React.createRef();
        _this.layout = React.createRef();
        _this.sidebar = React.createRef();
        _this.state = {
            isSticky: false,
            headerHeight: 0,
            scrollLeft: 0,
        };
        return _this;
    }
    Layout.prototype.componentDidrender = function () {
        var _this = this;
        var enableSticky = this.props.enableSticky;
        if (enableSticky) {
            addListener('scroll', this.handleScrollY);
            this.updateTimelineHeaderScroll();
            this.updateTimelineBodyScroll();
        }
        addListener('resize', this.handleResize);
        this.handleLayoutChange(function () { return _this.scrollToNow(); });
    };
    Layout.prototype.componentDidUpdate = function (prevProps, prevState) {
        var _a = this.props, enableSticky = _a.enableSticky, isOpen = _a.isOpen;
        var _b = this.state, isSticky = _b.isSticky, scrollLeft = _b.scrollLeft;
        if (enableSticky && isSticky) {
            if (!prevState.isSticky) {
                this.updateTimelineHeaderScroll();
            }
            if (scrollLeft !== prevState.scrollLeft) {
                this.updateTimelineBodyScroll();
            }
        }
        if (isOpen !== prevProps.isOpen) {
            this.handleLayoutChange();
        }
    };
    Layout.prototype.componentWillUnrender = function () {
        var enableSticky = this.props.enableSticky;
        if (enableSticky) {
            removeListener('scroll', this.handleScrollY);
            removeListener('resize', this.handleResize);
        }
    };
    Layout.prototype.render = function () {
        var _a = this.props, isOpen = _a.isOpen, tracks = _a.tracks, now = _a.now, time = _a.time, timebar = _a.timebar, toggleTrackOpen = _a.toggleTrackOpen, _b = _a.sidebarWidth, sidebarWidth = _b === void 0 ? 0 : _b, _c = _a.timelineViewportWidth, timelineViewportWidth = _c === void 0 ? 0 : _c, clickElement = _a.clickElement, clickTrackButton = _a.clickTrackButton;
        var _d = this.state, isSticky = _d.isSticky, headerHeight = _d.headerHeight, scrollLeft = _d.scrollLeft;
        return (_jsxs("div", __assign({ className: "rt-layout ".concat(isOpen ? 'rt-is-open' : ''), ref: this.layout }, { children: [_jsx("div", __assign({ className: "rt-layout__side", ref: this.sidebar }, { children: _jsx(Sidebar, { timebar: timebar, tracks: tracks, toggleTrackOpen: toggleTrackOpen, sticky: { isSticky: isSticky, headerHeight: headerHeight, sidebarWidth: sidebarWidth }, clickTrackButton: clickTrackButton }) })), _jsx("div", __assign({ className: "rt-layout__main" }, { children: _jsx("div", __assign({ className: "rt-layout__timeline", tabIndex: 0, ref: this.timeline, onScroll: isSticky ? this.handleScrollX : noop }, { children: _jsx(Timeline, { now: now, time: time, timebar: timebar, tracks: tracks, sticky: {
                                isSticky: isSticky,
                                setHeaderHeight: this.setHeaderHeight,
                                viewportWidth: timelineViewportWidth,
                                handleHeaderScrollY: this.handleHeaderScrollY,
                                headerHeight: headerHeight,
                                scrollLeft: scrollLeft,
                            }, clickElement: clickElement }) })) }))] })));
    };
    return Layout;
}(PureComponent));
export default Layout;
